<template>
  <div class="row">
    <a-row class="row">
      <a-col :span="12" class="title">
        事件配置
      </a-col>
      <a-col :span="12" style="text-align: right">
        <a-button class='button' type='primary' @click='handleAdd'>新增</a-button>
      </a-col>
    </a-row>
    <a-table :columns='columns'
             :dataSource='dataSource'
             :loading='loading'
             :pagination='false'
             :scroll="{y:'420px'}"

             rowKey='id'
             size='small'>
      <span slot="formItem" slot-scope="text, record, index">
                <template v-if="record.formList">
                  <template v-for="(item,index) in record.formList">
                    <a-tag style='text-align: center;width: 80px' v-if="index<7" :key="index">
                      <a-tooltip >
                        <template slot="title">
                          {{item.formName}}
                        </template>
                        <div class="one-row">
                          {{item.formName}}
                        </div>
                      </a-tooltip>
                    </a-tag>
                    <a-tag style='text-align: center;width: 80px' v-if="index===8" :key="index">
                      <a-tooltip >
                        <template slot="title">
                          {{item.formName}}
                        </template>
                        <div class="one-row">
                          ......
                        </div>
                      </a-tooltip>
                    </a-tag>
                  </template>
                </template>
              </span>
      <span slot="action" slot-scope="text, record, index">
        <a-dropdown>
            <a class="ant-dropdown-link">
              操作 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                    <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item>
                    <a @click="handleView(record)">查看</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
              </span>
    </a-table>
    <!--事件配置-表单选择-->
    <event-model ref="modalForm" @close="modelClose"></event-model>
  </div>

</template>

<script>
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EventModel from './EventModel'
  export default {
    name: 'EventList',
    components: { EventModel },
    mixins:[JeecgListMixin],
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        disableMixinCreated:true,
        /* 排序参数 */
        isorter:{
          column: 'sortNum',
          order: 'asc',
        },
        columns:[
          {
            title: '排序',
            align: 'center',
            dataIndex: 'sortNum',
            width: 60
          },
          {
            title: '事件名称',
            dataIndex: 'name',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '包含表单数',
            dataIndex: 'formCount',
            align: 'center',
            customRender:(text,record)=>{
              return record.formList?record.formList.length : 0
            },
            width: 90
          },
          {
            title: '表单详情',
            dataIndex: 'formItem',
            scopedSlots: { customRender: 'formItem' },
          },
          {
            title: '操作',
            align: 'center',
            width: 60,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url:{
          list:'/project/projectVisit/list',
          delete:'/project/projectVisit/delete'
        }
      }
    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods:{
      modelClose(){
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  .row{
    margin-bottom: 10px;
  }
</style>